
import { Component, Mixins } from "vue-property-decorator";
import { mapState } from "vuex";
import AuthenticateMixin from "../../common/mixins/auth.mixin";
import VacancyCard from "./components/vacancy-card.vue";
import VacancyCreateEditModal from "./components/vacancy-create-edit-modal.vue";
import VacancyApplicantModal from "./components/vacancy-applicant-modal.vue";
import { VacancyDto } from "@/types/vacancy.type";

@Component({
  components: {
    VacancyCard,
    VacancyCreateEditModal,
    VacancyApplicantModal
  },
  computed: {
    ...mapState("Vacancy", ["vacancies"])
  }
})
export default class VacancyComponent extends Mixins(AuthenticateMixin) {
  vacancies!: VacancyDto[];
  selectedId = 0;
  loading = true;

  async created(): Promise<void> {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  async getData(): Promise<void> {
    await this.$store.dispatch("Shift/getOffices", { userId: this.userInfo()?.sub });
    await this.$store.dispatch("Vacancy/get", this.userInfo()?.practiceId);
  }

  async showApplicantModal(id: number): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("Vacancy/getDetails", { id, practiceId: this.userInfo()?.practiceId });
    this.$bvModal.show("vacancy-applicant-modal");
    this.loading = false;
  }

  async fill(vacancyId: number): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("Vacancy/updateFill", vacancyId);
    await this.getData();
    this.loading = false;
  }

  async repost(vacancyId: number): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("Vacancy/repost", vacancyId);
    await this.getData();
    this.loading = false;
  }

  showCreateModal(): void {
    this.selectedId = 0;
    this.$store.dispatch("Vacancy/resetForm");
    this.$bvModal.show("vacancy-create-edit-modal");
  }

  showEditModal(id: number): void {
    this.selectedId = id;
    this.$bvModal.show("vacancy-create-edit-modal");
  }

  showDeleteModal(id: number): void {
    this.selectedId = id;
    this.$bvModal.show("vacancy-delete-modal");
  }

  async deleteVacancy(): Promise<void> {
    this.loading = true;
    await this.$store.dispatch("Vacancy/delete", this.selectedId);
    await this.getData();
    this.loading = false;
  }
}
